import axios from "axios";
import { getToken } from "../../auth/authService";

const api = axios.create({
  baseURL: process.env.REACT_APP_BASE_URL,
  headers: {
    Authorization: `Bearer ${getToken()}`,
    "Content-Type": "application/json",
  },
});

/* ===============================
   ADMIN SUPPORT APIs
================================ */

/**
 * Get all tickets
 */
export const getAllTickets = () => api.get("/admin/support/tickets");

/**
 * Get ticket + conversation by ticket ID
 * @param {number} ticketId
 */
export const getTicketDetail = (ticketId) =>
  api.get(`/admin/support/tickets/${ticketId}`);

/**
 * Reply to ticket
 * @param {number} ticketId
 * @param {{ message: string }} payload
 */
export const replyToTicket = (ticketId, payload) =>
  api.post(`/admin/support/tickets/${ticketId}/reply`, payload);

/**
 * Update ticket status
 * @param {number} ticketId
 * @param {string} status
 */
export const updateTicketStatus = (ticketId, status) =>
  api.put(`/admin/support/tickets/${ticketId}/status`, null, {
    params: { status },
  });
